// NOTICE: KAPTION-INTEGRATION
// whatsapp-calling.WEB.1 — a synthesized ring (no audio asset to ship).
// Two-tone burst every 3 s while ringing; a single soft beep (call waiting)
// when the agent is already on a call. Autoplay policy may block it until the
// first user gesture; the toast and the desktop notification still show.
let context = null;
let timer = null;

const beep = (ctx, { frequency, start, duration, gain }) => {
  const osc = ctx.createOscillator();
  const amp = ctx.createGain();
  osc.frequency.value = frequency;
  amp.gain.setValueAtTime(0, ctx.currentTime + start);
  amp.gain.linearRampToValueAtTime(gain, ctx.currentTime + start + 0.02);
  amp.gain.linearRampToValueAtTime(0, ctx.currentTime + start + duration);
  osc.connect(amp).connect(ctx.destination);
  osc.start(ctx.currentTime + start);
  osc.stop(ctx.currentTime + start + duration + 0.05);
};

const ringOnce = (ctx, waiting) => {
  if (waiting) {
    beep(ctx, { frequency: 440, start: 0, duration: 0.25, gain: 0.08 });
    return;
  }
  [0, 0.45].forEach(start => {
    beep(ctx, { frequency: 480, start, duration: 0.35, gain: 0.15 });
    beep(ctx, { frequency: 620, start, duration: 0.35, gain: 0.1 });
  });
};

export const startRingtone = ({ waiting = false, sinkId = null } = {}) => {
  stopRingtone(); // eslint-disable-line no-use-before-define
  const AudioContextImpl = window.AudioContext || window.webkitAudioContext;
  if (!AudioContextImpl) return;
  try {
    context = context || new AudioContextImpl();
    // DESKTOP.4 — ring on the chosen output (AudioContext.setSinkId).
    if (sinkId && context.setSinkId) context.setSinkId(sinkId).catch(() => {});
    context.resume?.().catch(() => {});
    ringOnce(context, waiting);
    timer = setInterval(() => ringOnce(context, waiting), 3000);
  } catch (e) {
    // audio unavailable — silent ring
  }
};

export function stopRingtone() {
  if (timer) clearInterval(timer);
  timer = null;
}
